import React from 'react';
import './fenotices.scss';

import { createStore } from 'devextreme-aspnet-data';
import DataGrid, {
  Column,
  //Button,
  Pager,
  Paging,
  FilterRow,
  Lookup,
  Editing,
  Selection,
  Toolbar,
  Item,
  Summary,
  GroupItem,
  TotalItem,
  SearchPanel
} from 'devextreme-react/data-grid';

import { useAuth } from  '../../contexts/auth';
import { DateBox } from 'devextreme-react/date-box'; 
import { useState, useEffect, useMemo } from "react";
import {Button as ToolbarButton} from 'devextreme-react/button';
import {Logout, IsRole_Designer, tipoEventoFEOptions} from '../../globals';
import notify from 'devextreme/ui/notify';

import { confirm } from 'devextreme/ui/dialog';

const debug = process.env.ENTITY_DEBUG;
const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/EventoFE'



export default function FENotices() {

  const { user} = useAuth(); 
  const isDesigner = IsRole_Designer();

  if (!user) 
    Logout();

  const defaultStartDate = new Date();
  defaultStartDate.setMonth(defaultStartDate.getMonth() - 1);
  const defaultEndDate = new Date();
  const [tipiDocumento, setTipoDocumento] = useState({});
  const [currentRow, setCurrentRow] = useState(1);
  const [currentUuid, setCurrentUuid] = useState();
  const [isRowSelected, setIsRowSelected] = useState(false);
  const [startDate, setStartDate] = useState(defaultStartDate);
  const [endDate, setEndDate] = useState(defaultEndDate);
  const [typeFilter, setTypeFilter] = useState();

   var fenoticesDataGridRef = React.createRef();

  const remoteDataSource = useMemo(() => {
    return createStore({
      key: 'id',
      loadUrl: serviceUrl + '/Find',

      onBeforeSend: (method, ajaxOptions) => {
        if (method === "load") {
          const payload = ajaxOptions.data;
          payload.values = JSON.stringify({
            type: typeFilter,
            createdAtAfter: startDate,
            createdAtBefore: endDate,
          });
          ajaxOptions.data = payload;
        }

        ajaxOptions.headers = {
          Authorization: `Bearer ${user.token}`
        };
      }
    });
  }, [ typeFilter, startDate, endDate, user.token]);


  useEffect(() => {

    const fetchData = async () => {

    const newServiceUrl13 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_TipoDocumentiFiscali';
    var newUrl13 =  newServiceUrl13 + "/GetAction";

      try {

        const response13 = await fetch(newUrl13);
        const json13 = await response13.json();
        if (debug === 1)
          console.log(json13);
        setTipoDocumento(json13);


      } catch (error) {
        console.log("error", error);
      }
    };

    fetchData();
  }, []);


  const selectBoxOptions = {
    width: 210,
    items: tipoEventoFEOptions,
    valueExpr: 'id',
    displayExpr: 'desc',
    placeholder:"<Tipo Notifica>",
    showClearButton:true,
    onValueChanged: (args) => {
      setTypeFilter(args.value);
    },
    value: typeFilter
  };

  const startDateValueChanged = (e) => {
    setStartDate(e.value);
  };
  const endDateValueChanged = (e) => {
    setEndDate(e.value);
  };

  function downloadXML(e) {
    streamXML(currentUuid);
  };


  async function streamXML(uuid) {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_WEBAPP_DOMAIN}/api/OpenAPI/DownLoadXMLFE/${uuid}`,
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${user.token}`
          }
        }
      );

      if (!response.ok) {
        const error = await response.json();
        notify(error.message || 'Errore nel download XML', 'error', 5000);
        return;
      }

      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `XML_${uuid}.xml`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

    } catch (err) {
      notify('Errore di rete o server non disponibile', 'error', 5000);
    }
  }

 
  function print(e) {
    printInvoice(currentUuid);
  }

  async function printInvoice(uuid) {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_WEBAPP_DOMAIN}/api/OpenAPI/ExportInvoicePDF/${uuid}`,
        {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${user.token}`
          }
        }
      );

      if (!response.ok) {
        const error = await response.json();
        notify(error.message || 'Errore nel download XML', 'error', 5000);
        return;
      }

      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `PDF_${uuid}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

    } catch (err) {
      notify('Errore di rete o server non disponibile', 'error', 5000);
    }
  }

 

function deserialize(e) {
    let result = confirm("<i>Procedere con la normalizzazione dell'elemento selezionato?</i>", "Normalizza");
    result.then((dialogResult) => {
      if  (dialogResult) {
        deserializza(currentRow);
      }
    });
  };

  function deserializza(id) {
  
    const url = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/EventoFE/Deserialize/' + id;

    const requestOptions = {
      method: 'POST',
      //body: JSON.stringify(t),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${user.token}`
      }
    };

    fetch(url, requestOptions)
      .then(response => { 
        if(response.ok) return response.json();
        //Global.CheckResponseAuth(response);
        return null;             
      })
      .then(data => {
        notify(data.message, data.success ? 'success' : 'error', 5000);
        fenoticesDataGridRef.instance().refresh();
      })
      .catch(error => { notify(error, 'error', 10000); });
  };  
  

  function onRowSelectionChanged({ selectedRowsData }) {

    const data = selectedRowsData[0];
    if (data != null) {

      setCurrentRow(data.id);
      setCurrentUuid(data.invoiceUuid);
      setIsRowSelected(true);
    } else {
      setIsRowSelected(false);
      setCurrentUuid(null);
    }
 
  }


  return(
  <React.Fragment>
    <h2 className={'content-block'}>Notifiche FE</h2>
    <div className={'content-block'}>
      <div className={'dx-card responsive-paddings'}>
        
        <DataGrid
          dataSource={remoteDataSource}
          focusedRowEnabled={true}
          showBorders={true}
          onSelectionChanged={onRowSelectionChanged}
          ref={ref => fenoticesDataGridRef = ref}
        >
          <Toolbar>
             <Item location="before">
              <ToolbarButton className="offer-toolbar"
                icon='export'
                hint='XML'
                onClick={downloadXML}
                disabled={!isRowSelected} />
            </Item>
            <Item location="before">
              <ToolbarButton className="offer-toolbar"
                icon='print'
                hint='Pdf'
                onClick={print}
                disabled={!isRowSelected}
                visible={true} />
            </Item>
             <Item location="before">
              <ToolbarButton className="offer-toolbar"
                icon='aligncenter'
                hint='Deserializza'
                onClick={deserialize}
                visible={isDesigner}
                disabled={!isRowSelected} />
            </Item>
            <Item location="after">
              <div style={{ paddingRight: 8, paddingLeft: 8, fontWeight: 600 }}>
                Periodo:
              </div>
            </Item>
            <Item location="after">
              <DateBox
                value = {startDate}
                showClearButton={false}
                onValueChanged={startDateValueChanged}
              />
            </Item>
            <Item location="after">
              <DateBox
                value = {endDate}
                showClearButton={false}
                onValueChanged={endDateValueChanged}
              />
            </Item>
            <Item location="after"
              locateInMenu="auto"
              widget="dxSelectBox"
              options={selectBoxOptions} >
            </Item>
            <Item name="searchPanel" className="offer-toolbar"/>
           </Toolbar>
          <SearchPanel visible={true} width={240} placeholder="Cerca..." />
          <Selection mode="single" />
          <Editing
            mode="row"
            useIcons={true}
            allowAdding={false}
            allowDeleting={false}
            allowUpdating={false}     
          />
          <Column dataField="id" visible={true} width={60}/>
       
          <Column dataField="eventType" caption="Tipo" visible={true} >
            <Lookup dataSource={tipoEventoFEOptions} displayExpr="desc" valueExpr="id" />
          </Column>
          <Column dataField="createDate" caption= "Data notifica" dataType="date" format= {'dd/MM/yyyy hh:mm:ss'}/>
          <Column dataField="invoiceUuid" caption= "Id Fattura Openapi" visible={true} width={320}/>
          <Column dataField="invoiceType" caption="Tipo Documento"  visible={true}>
            <Lookup dataSource={tipiDocumento} valueExpr="codice" displayExpr="categoria" />
          </Column>
          <Column dataField="invoiceNumber" caption= "Num. Documento"/>
          <Column dataField="invoiceDate" caption= "Data Documento" dataType="date" format= {'dd/MM/yyyy'}/>
        
         
          <Column dataField="subject" caption= "Soggetto"/>
        </DataGrid>  

      </div>
    </div>
  </React.Fragment>
  )

};
